module.exports = require("web3-eth-ens");